import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { sendMetaEvent, hashEmail, hashPhone, hashName } from "./useMetaTracking";

export default function useSuccessfulMetaSubmission(succeeded, formData, contentName, trackContact = false) {
  const navigate = useNavigate();
  const trackedRef = useRef(false);
  const { email, phone, firstName, lastName } = formData;

  useEffect(() => {
    if (!succeeded) {
      trackedRef.current = false;
      return;
    }
    if (trackedRef.current) return;
    trackedRef.current = true;

    async function trackSubmission() {
      try {
        const [em, ph, fn, ln] = await Promise.all([
          hashEmail(email), hashPhone(phone), hashName(firstName), hashName(lastName),
        ]);
        const matchingData = {
          ...(em && { em }), ...(ph && { ph }), ...(fn && { fn }), ...(ln && { ln }),
        };
        if (trackContact) {
          sendMetaEvent("Contact", { content_name: contentName, ...matchingData });
        }
        sendMetaEvent("Lead", {
          content_name: contentName, value: 0, currency: "USD", ...matchingData,
        });
      } catch (error) {
        console.error("Meta submission tracking failed:", error.name);
      } finally {
        // A tracking failure must not prevent confirmation of a successful form.
        navigate("/thank-you");
      }
    }

    trackSubmission();
  }, [succeeded, email, phone, firstName, lastName, contentName, trackContact, navigate]);
}
